import type { IReportsLinksState } from '@/store/modules/report/reports-links/types';

export const state: IReportsLinksState = {
  links: [],
};
